/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Add_MaterialInputs */

const vi_packaging_add_material = /** @type {(inputs: Packaging_Add_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm vật tư`)
};

/**

* @param {Packaging_Add_MaterialInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_add_material = /** @type {((inputs?: Packaging_Add_MaterialInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Add_MaterialInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_add_material(inputs)
});